import { cn } from "@/lib/utils";
import { Helmet } from "react-helmet";

type Props = {
  title: string;
  color?: string;
  isMobile?: boolean;
  children?: JSX.Element;
  maxWidth?: string;
  helmetTitle: string;
  helmetContent: string;
  helmetLink: string;
  subtleTitle?: boolean;
};

export const PageHeader = ({
  title,
  color,
  isMobile,
  children,
  maxWidth,
  helmetTitle,
  helmetContent,
  helmetLink,
  subtleTitle,
}: Props) => {
  return isMobile ? (
    <>
      {helmetTitle && (
        <Helmet>
          <title>{helmetTitle}</title>
          <meta name="description" content={helmetContent} />
          <link rel="canonical" href={helmetLink} />
        </Helmet>
      )}
      <div className="flex flex-col gap-y-1 p-2 bg-black text-left">
        <h1 className="text-sm text-dark-secondary">{title}</h1>
        <h2 className="text-xs text-dark-tertiary">{helmetContent}</h2>
      </div>
      {children && (
        <header
          className={cn(
            "w-full h-fit text-white flex justify-center text-xs",
            color,
          )}
        >
          <div
            className={cn("flex flex-row ", maxWidth, "w-full justify-between")}
          >
            {children}
          </div>
        </header>
      )}
    </>
  ) : (
    <header
      className={cn(
        "w-full h-fit py-2 text-white flex justify-center text-xs desktop:text-base",
        color,
      )}
    >
      {helmetTitle && (
        <Helmet>
          <title>{helmetTitle}</title>
          <meta name="description" content={helmetContent} />
          <link rel="canonical" href={helmetLink} />
        </Helmet>
      )}
      <div
        className={cn(
          "flex flex-row desktop:px-8 ",
          maxWidth,
          "w-full justify-between",
        )}
      >
        <section className="flex flex-col items-start justify-start my-auto text-left">
          <h1
            className={cn(
              subtleTitle ? "text-dark-secondary" : "text-dark-primary",
            )}
          >
            {title}
          </h1>
          <h2
            className={cn(
              "text-sm",
              subtleTitle ? "text-dark-tertiary" : "text-dark-secondary",
            )}
          >
            {helmetContent}
          </h2>
        </section>
        {children}
      </div>
    </header>
  );
};
